import * as CargoDocCfmState from '@/class/cargo/model/parameters/CargoDocCfmState'
import * as ReleaseState from '@/class/cargo/model/parameters/ReleaseState'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import { DocCommon } from '@/class/cargo/model/utils/DocCommon'
import { SeaExportUtils } from '@/class/cargo/model/utils/SeaExportUtils'
import { Company } from '@/class/model/mdm/Company'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { EDIContainer } from '@/class/model/booking/EDIContainer'
import { isArray } from '@/utils/validate'
import StrUtils from '@/utils/StrUtils'
import { unJointSlavesHblOrMbl } from '@/api/seaExport/seaExportJob'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { sortByMultiFieldAndOrder } from '@/utils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { Message } from '@/utils/Message'
import lang from '@/lang'
import { StatusChangeHistory } from '@/class/model/booking/StatusChangeHistory'
import { CheckCargoDocHistory } from '@/class/model/booking/CheckCargoDocHistory'
import { MBL2 } from '@/class/cargo/model/parameters/CargoDocConsts'
import ColumnUtils from '@/utils/ColumnUtils'
import { manualTriggerAndUpate, updateReleasestate } from '@/api/seaExport/seaExportJob'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import * as AutomaticReleaseConstants from '@/class/cargo/model/parameters/AutomaticReleaseConstants'
import { getLoading } from '@/utils/utilBaseElement'
import { cancelRequestRelease, requestRelease, executeRuleEngine } from '@/api/seaExport/seaCargoDoc'

export class TabMBL2PM {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    this.view = view
    // In some entry points the passed view may not have ElementUI injected.
    // Fallback to the global Message util to avoid runtime errors.
    this.$message = view.$message || Message
    this.$confirm = view.$confirm
    this.$i18n = view.$i18n
    this._mblCargoDoc = null
    this.mergerOfEnglishNames = 0
  }
  get context() {
    return this.view.context
  }
  set context(context) {
    // 不可赋值
  }
  get companyList() {
    return this.view.context.companyList
  }
  set companyList(companyList) {
    // 不可赋值
  }
  get paymentTermList() {
    return this.view.context.paymentTermList
  }
  set paymentTermList(paymentTermList) {
    // 不可赋值
  }
  get packingList() {
    return this.view.context.packingList
  }
  set packingList(packingList) {
    // 不可赋值
  }
  get config() {
    return this.view.config
  }
  set config(config) {
    // 不可赋值
  }
  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }
  get form() {
    return this.view.form
  }
  set form(form) {
    this.view.form = form
  }
  init() {
    this.view.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = Number(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
    this.view.mblMergeUpdateMainNumber = Number(this.config.get('mblMergeUpdateMainNumber')) === 2
    this.view.maxChars = Number(this.config.get('SEShipperConsigneNotifyMaxchars'))
    this.view.warningCount = Number(this.config.get('SEShipperConsigneNotifyWarningColor'))
    this.view.seMarkMaxChars = Number(this.config.get('SEMarkMaxChars'))
    this.view.seMarkWarningColor = Number(this.config.get('SEMarkWarningColor'))
    this.mergerOfEnglishNames = Number(this.config.get('MergerOfEnglishNames'))
    this.view.editMblNoMode = Number(this.config.get('EditMblNoMode'))
    for (const item of this.context.blModeList) {
      if (item.blType === 2) {
        this.view.blModeList.push(item)
      }
    }
  }
  async display() {
    const job = new SeaExportJob(this.job)
    const cargoDoc = await job.getSeaCargoDoc()
    this.loadCargoDoc2Handler(cargoDoc)
    const jointSlavesMBL = await job.getJointSlavesMBL()
    this.loadJointSlaves2Handler(jointSlavesMBL)
  }
  async changeJob() {
    this.view.warningCount = Number(this.config.get('SEShipperConsigneNotifyWarningColor'))
    const cmp = this.companyList.find(p => p.cmpIdx === this.job.carrierId)
    if (cmp) {
      await new Company(cmp).getShipping()
      this.loadShippingResult(cmp)
    }
  }
  async fillView() {
    this.refreshQuantitySum()
    this.resetColor()
    if (this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code ||
          this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_SHIPPER_CONFIRMED.code) {
      await this.loadCheckDocs()
    }
  }
  async checkSpecialCharacter() {
    if (Number(this.config.get('SpecialCharacterCheck')) === 1) {
      for (const key in this.view.specialCharCheck) {
        this.view.specialCharCheck[key] = StrUtils.getSpecialTexts(this.form[key])
      }
    } else {
      for (const key in this.view.specialCharCheck) {
        this.view.specialCharCheck[key] = null
      }
    }
  }
  fillModel() {
    if (this.form.mblNbr2) {
      for (const item of this.view.splitOrder.rowData) {
        if (this.form !== item && this.form.mblNbr2 === item.mblNbr2) {
          this.$message.warning(this.view.$t('Message.MBLNOCannotBeDuplicated'))
        }
      }
    }
    this.form.shipperLine7 = this.form.shipperLine7 || ''
    this.form.consigneeLine7 = this.form.consigneeLine7 || ''
    this.form.notifyLine7 = this.form.notifyLine7 || ''
    this.view.$store.dispatch('log/addLog', {
      type: 'info',
      msg: 'mbl2:' + this.form,
      url: window.location.href
    })
    // 提单发货地
    this.form.dispatchingPlace = this.form.dispatchingPlace.toUpperCase()
    // 提单起运港
    this.form.loadingPort = this.form.loadingPort.toUpperCase()
    // 提单卸货港
    this.form.dischargingPort = this.form.dischargingPort.toUpperCase()
    // 提单目的港
    this.form.destinationPort = this.form.destinationPort.toUpperCase()
    // 提单目的地
    this.form.destinationPlace = this.form.destinationPlace.toUpperCase()

    // 开航日期
    // MBL付款方式
    this.form.paymentTerm = this.form.paymentTerm.toUpperCase()
    // 提单份数
    this.form.blNumber = this.form.blNumber.toUpperCase()
    // 英文品名
    // this.form.cargoEnglishName = this.form.cargoEnglishName.toUpperCase()
    // 签发地点
    this.form.signPlaceBL = this.form.signPlaceBL.toUpperCase()
    // 唛头
    // this.form.mark = this.form.mark.toUpperCase()

    this.form.alsoNotify = this.form.alsoNotify.toUpperCase()

    // 提单备注
    this.form.remarks = this.form.remarks.toUpperCase()
    this.form.seaeq = this.form.seaeq.toUpperCase()
    this.form.container = this.form.container.toUpperCase()
    // 处理特殊字符
    JobUtils.handlingSpecialCharactersForCargoDoc(this.form)
  }
  validateForm() {
    let _t_quantity = 0
    let _t_weight = 0
    let _t_cubage = 0
    if (this.job.typeMBL === BillType.SPLIT_BILL_TYPE.code) {
      // MBL拆单,子单件毛体总和
      for (const doc1 of this.view.splitOrder.rowData) {
        if (doc1.deleted) continue
        if (doc1.docType === CargoDocConsts.MBL2) {
          // 件数
          _t_quantity += Number(doc1.quantity)
          // 重量
          _t_weight += Number(doc1.weight)
          // 体积
          _t_cubage += Number(doc1.cubage)
        }
      }
      if ((_t_quantity !== 0 && _t_quantity !== Number(this.job.quantityActual)) ||
        (_t_weight !== 0 && _t_weight.toFixed(2) !== Number(this.job.weightActual).toFixed(2)) ||
        (_t_cubage !== 0 && _t_cubage.toFixed(3) !== Number(this.job.cubageActual).toFixed(3))) {
        // throw new TabError(this.view.$t('Message.TotalWeightOfLadingAreInconsistent'), 'tabMBL2')
        Message.warning(lang.t('Message.TotalWeightOfLadingAreInconsistent'))
      }
    } else if (this.job.typeMBL === BillType.MERGE_BILL_TYPE.code) {
      for (const doc2 of this.job.seaCargoDoc) {
        // 当前订单MBL件毛体
        if (doc2.docType === CargoDocConsts.MBL) {
          // 件数
          _t_quantity += Number(doc2.quantity)
          // 重量
          _t_weight += Number(doc2.weight)
          // 体积
          _t_cubage += Number(doc2.cubage)
          break
        }
      }
      // 并单件毛体
      for (const job of this.job.jointSlavesMBL) {
        _t_quantity += Number(job.quantityActual)
        // 重量
        _t_weight += Number(job.weightActual)
        // 体积
        _t_cubage += Number(job.cubageActual)
      }
      if (this.form.quantity && this.form.weight && this.form.cubage && ((_t_quantity !== 0 && _t_quantity !== Number(this.form.quantity)) ||
        (_t_weight !== 0 && _t_weight.toFixed(2) !== Number(this.form.weight).toFixed(2)) ||
        (_t_cubage !== 0 && _t_cubage.toFixed(3) !== Number(this.form.cubage).toFixed(3)))) {
        // throw new TabError(this.view.$t('Message.TotalWeightOfLadingAreInconsistent'), 'tabMBL2')
        Message.warning(lang.t('Message.TotalWeightOfLadingAreInconsistent'))
      }
    }
    return true
  }
  print() {
    // if (null == view.cargoDoc) {
    //   this.$message.warning(this.view.$t('Message.NoSelectedCargoDocInformation'))
    //   return
    // }
    // var params = new Object()
    // if (view.job.typeMBL == BillType.SPLIT_BILL_TYPE.code) {
    //   if (view.gdMBL2.selectedItem) {
    //     params.jobuuid = view.job.key
    //     params.cargoDocUuid = view.cargoDoc.key
    //     params.DOC_UUID = view.cargoDoc.key
    //     TemplateSelectorWin.getInstance().showThisWin(view.job, "MBL2", params, view)
    //   }
    //   else {
    //     this.$message.warning(this.view.$t('Message.NoSelectedCargoDocInformation'))
    //   }
    // }
    // else if (view.job.typeMBL == BillType.MERGE_BILL_TYPE.code) {
    //   if (view.cargoDoc) {
    //     params.jobuuid = view.job.key
    //     params.cargoDocUuid = this.view.cargoDoc.key
    //     params.DOC_UUID = this.view.cargoDoc.key
    //     TemplateSelectorWin.getInstance().showThisWin(view.job, "MBL2", params, view)
    //   }
    // }
  }
  /**
   * save task
   */
  executeTask() {
    DocCommon.MBL_History.shipperLine1 = this.form.shipperLine1
    DocCommon.MBL_History.shipperLine2 = this.form.shipperLine2
    DocCommon.MBL_History.shipperLine3 = this.form.shipperLine3
    DocCommon.MBL_History.shipperLine4 = this.form.shipperLine4
    DocCommon.MBL_History.shipperLine5 = this.form.shipperLine5
    DocCommon.MBL_History.shipperLine6 = this.form.shipperLine6
    DocCommon.MBL_History.shipperCode = this.form.shipperCode
    DocCommon.MBL_History.consigneeLine1 = this.form.consigneeLine1
    DocCommon.MBL_History.consigneeLine2 = this.form.consigneeLine2
    DocCommon.MBL_History.consigneeLine3 = this.form.consigneeLine3
    DocCommon.MBL_History.consigneeLine4 = this.form.consigneeLine4
    DocCommon.MBL_History.consigneeLine5 = this.form.consigneeLine5
    DocCommon.MBL_History.consigneeLine6 = this.form.consigneeLine6
    DocCommon.MBL_History.consigneeCode = this.form.consigneeCode
    DocCommon.MBL_History.notifyLine1 = this.form.notifyLine1
    DocCommon.MBL_History.notifyLine2 = this.form.notifyLine2
    DocCommon.MBL_History.notifyLine3 = this.form.notifyLine3
    DocCommon.MBL_History.notifyLine4 = this.form.notifyLine4
    DocCommon.MBL_History.notifyLine5 = this.form.notifyLine5
    DocCommon.MBL_History.notifyLine6 = this.form.notifyLine6
    DocCommon.MBL_History.notifyCode = this.form.notifyCode
    DocCommon.MBL_History.englishCargoName = this.form.cargoEnglishName
    DocCommon.MBL_History.mark = this.form.mark
    this.view.addrPM.isMBL = true
    this.view.addrPM.job = this.job
    this.view.addrPM.shipperCodeField = 'shipperCode'
    this.view.addrPM.shipperField = 'shipperLine'
    this.view.addrPM.consigneeCodeField = 'consigneeCode'
    this.view.addrPM.consigneeField = 'consigneeLine'
    this.view.addrPM.notifyCodeField = 'notifyCode'
    this.view.addrPM.notifyField = 'notifyLine'
    if (parseInt(this.config.get('syncMailingAddress')) === 1) {
      this.view.addrPM.saveCheck()
    }
    this.view.addJoinMergeJobList = []
  }
  loadCargoDoc2Handler(cargoDocList) {
    const cargoDocs = []
    if (cargoDocList.length > 0) {
      for (const item of cargoDocList) {
        if (item.docType === CargoDocConsts.MBL) {
          this._mblCargoDoc = item
        } else if (item.docType === CargoDocConsts.MBL2) {
          cargoDocs.push(item)
        }
      }
      this.view.splitOrder.rowData = sortByMultiFieldAndOrder(cargoDocs, { mblNbr2: 'asc', hblNbr2: 'asc' })
    }
    if (cargoDocs.length > 0) {
      this.form = cargoDocs[0]
      this.view.showEdiContainer = true
    } else {
      if (this.job.typeMBL === BillType.MERGE_BILL_TYPE.code) {
        this.view.showEdiContainer = true // 并单默认显示提单装箱信息
        this.onAddSplitDocEvent()
      }
    }
    if (this.job.typeMBL === BillType.MERGE_BILL_TYPE.code) {
      this.job.seaCargoDoc.push(this.form)
    }
    if (this.job.typeMBL === BillType.MERGE_BILL_TYPE.code) {
      this.form.hblNbr2 = this.job.jobNo
    }
    if (!this.form.paymentTerm) {
      const paymentTerm = this.paymentTermList.find(p => p.code === this.job.paymentTermMBL)
      this.form.paymentTerm = paymentTerm ? paymentTerm.name : ''
    }
    new SeaCargoDoc(this.form).getEdiContainer().then(data => {
      this.view.rowData = data
    })
    this.showScac()
    this.showDocState()
  }
  loadJointSlaves2Handler(jointSlavesMBL) {
    this.view.mergeOrder.rowData = jointSlavesMBL
  }
  loadShippingResult(cmp) {
    if (cmp && cmp.shipping) {
      for (const item of cmp.shipping) {
        if (item.branchId === this.job.opOffice) {
          this.view.warningCount = Number(this.config.get('SEShipperConsigneNotifyWarningColor'))
          return
        }
      }
    }
  }
  /**
   *  提单方式
   */
  cmbreleaseTypeMBLChangeHandler(value) {
    this.form.blNumber = Number(value) === 1 ? 'THREE' : 'ONE'
  }
  onCopy1() {
    this.form.shipperCode = DocCommon.MBL_History.shipperCode || ''
    this.form.shipperLine1 = DocCommon.MBL_History.shipperLine1 || ''
    this.form.shipperLine2 = DocCommon.MBL_History.shipperLine2 || ''
    this.form.shipperLine3 = DocCommon.MBL_History.shipperLine3 || ''
    this.form.shipperLine4 = DocCommon.MBL_History.shipperLine4 || ''
    this.form.shipperLine5 = DocCommon.MBL_History.shipperLine5 || ''
    this.form.shipperLine6 = DocCommon.MBL_History.shipperLine6 || ''
    this.form.consigneeCode = DocCommon.MBL_History.consigneeCode || ''
    this.form.consigneeLine1 = DocCommon.MBL_History.consigneeLine1 || ''
    this.form.consigneeLine2 = DocCommon.MBL_History.consigneeLine2 || ''
    this.form.consigneeLine3 = DocCommon.MBL_History.consigneeLine3 || ''
    this.form.consigneeLine4 = DocCommon.MBL_History.consigneeLine4 || ''
    this.form.consigneeLine5 = DocCommon.MBL_History.consigneeLine5 || ''
    this.form.consigneeLine6 = DocCommon.MBL_History.consigneeLine6 || ''
    this.form.notifyCode = DocCommon.MBL_History.notifyCode || ''
    this.form.notifyLine1 = DocCommon.MBL_History.notifyLine1 || ''
    this.form.notifyLine2 = DocCommon.MBL_History.notifyLine2 || ''
    this.form.notifyLine3 = DocCommon.MBL_History.notifyLine3 || ''
    this.form.notifyLine4 = DocCommon.MBL_History.notifyLine4 || ''
    this.form.notifyLine5 = DocCommon.MBL_History.notifyLine5 || ''
    this.form.notifyLine6 = DocCommon.MBL_History.notifyLine6 || ''
    this.form.cargoEnglishName = DocCommon.MBL_History.englishCargoName || ''
    this.form.mark = DocCommon.MBL_History.mark || ''
  }
  selectionItemHandler(rows) {
    const selectedMBL = isArray(rows) ? rows[0] : rows
    if (selectedMBL && Object.keys(selectedMBL).length > 0) {
      this.form.shipperCode = selectedMBL.shipperCode
      this.form.shipperLine1 = selectedMBL.shipperLine1
      this.form.shipperLine2 = selectedMBL.shipperLine2
      this.form.shipperLine3 = selectedMBL.shipperLine3
      this.form.shipperLine4 = selectedMBL.shipperLine4
      this.form.shipperLine5 = selectedMBL.shipperLine5
      this.form.shipperLine6 = selectedMBL.shipperLine6
      this.form.consigneeCode = selectedMBL.consigneeCode
      this.form.consigneeLine1 = selectedMBL.consigneeLine1
      this.form.consigneeLine2 = selectedMBL.consigneeLine2
      this.form.consigneeLine3 = selectedMBL.consigneeLine3
      this.form.consigneeLine4 = selectedMBL.consigneeLine4
      this.form.consigneeLine5 = selectedMBL.consigneeLine5
      this.form.consigneeLine6 = selectedMBL.consigneeLine6
      this.form.notifyCode = selectedMBL.notifyCode
      this.form.notifyLine1 = selectedMBL.notifyLine1
      this.form.notifyLine2 = selectedMBL.notifyLine2
      this.form.notifyLine3 = selectedMBL.notifyLine3
      this.form.notifyLine4 = selectedMBL.notifyLine4
      this.form.notifyLine5 = selectedMBL.notifyLine5
      this.form.notifyLine6 = selectedMBL.notifyLine6
      this.form.cargoEnglishName = this.job.cargoEnglishName
      this.form.mark = this.job.mark
    }
  }
  /**
   * 抄录收货人
   */
  onCopyConsignee(detail) {
    this.form.notifyCode = this.form.consigneeCode
    this.form.notifyLine1 = this.form.consigneeLine1
    this.form.notifyLine2 = this.form.consigneeLine2
    this.form.notifyLine3 = this.form.consigneeLine3
    if (detail) {
      this.form.notifyCountry = this.form.consigneeCountry
      this.form.notifyCity = this.form.consigneeCity
      this.form.notifyProvince = this.form.consigneeProvince
      this.form.notifyZipCode = this.form.consigneeZipCode
      this.form.notifyMobile = this.form.consigneeMobile
      this.form.notifyEmail = this.form.consigneeEmail
      this.form.notifyFax = this.form.consigneeFax
      this.form.notifyContact = this.form.consigneeContact
    } else {
      this.form.notifyLine4 = this.form.consigneeLine4
      this.form.notifyLine5 = this.form.consigneeLine5
      this.form.notifyLine6 = this.form.consigneeLine6
      this.form.notifyLine7 = this.form.consigneeLine7
    }
  }
  /**
   * 添加拆单
   */
  async onAddSplitDocEvent() {
    this.view.showEdiContainer = true
    this.fillModel()
    this.form = new SeaCargoDoc().fillDefaultValue().getData()
    await SeaCargoDoc.copyInfoFromSeaExportJob(this.job, this.form)
    this.form.docType = CargoDocConsts.MBL2
    if (this._mblCargoDoc) {
      this.form.shipperLine1 = this._mblCargoDoc.shipperLine1
      this.form.shipperLine2 = this._mblCargoDoc.shipperLine2
      this.form.shipperLine3 = this._mblCargoDoc.shipperLine3
      this.form.shipperLine4 = this._mblCargoDoc.shipperLine4
      this.form.shipperLine5 = this._mblCargoDoc.shipperLine5
      this.form.shipperLine6 = this._mblCargoDoc.shipperLine6
      this.form.shipperLine7 = this._mblCargoDoc.shipperLine7
      this.form.shipperCode = this._mblCargoDoc.shipperCode
      this.form.shipperCountry = this._mblCargoDoc.shipperCountry
      this.form.shipperCity = this._mblCargoDoc.shipperCity
      this.form.shipperProvince = this._mblCargoDoc.shipperProvince
      this.form.shipperZipCode = this._mblCargoDoc.shipperZipCode
      this.form.shipperMobile = this._mblCargoDoc.shipperMobile
      this.form.shipperEmail = this._mblCargoDoc.shipperEmail
      this.form.shipperFax = this._mblCargoDoc.shipperFax
      this.form.shipperContact = this._mblCargoDoc.shipperContact

      this.form.consigneeLine1 = this._mblCargoDoc.consigneeLine1
      this.form.consigneeLine2 = this._mblCargoDoc.consigneeLine2
      this.form.consigneeLine3 = this._mblCargoDoc.consigneeLine3
      this.form.consigneeLine4 = this._mblCargoDoc.consigneeLine4
      this.form.consigneeLine5 = this._mblCargoDoc.consigneeLine5
      this.form.consigneeLine6 = this._mblCargoDoc.consigneeLine6
      this.form.consigneeLine7 = this._mblCargoDoc.consigneeLine7
      this.form.consigneeCode = this._mblCargoDoc.consigneeCode
      this.form.consigneeCountry = this._mblCargoDoc.consigneeCountry
      this.form.consigneeCity = this._mblCargoDoc.consigneeCity
      this.form.consigneeProvince = this._mblCargoDoc.consigneeProvince
      this.form.consigneeZipCode = this._mblCargoDoc.consigneeZipCode
      this.form.consigneeMobile = this._mblCargoDoc.consigneeMobile
      this.form.consigneeEmail = this._mblCargoDoc.consigneeEmail
      this.form.consigneeFax = this._mblCargoDoc.consigneeFax
      this.form.consigneeContact = this._mblCargoDoc.consigneeContact

      this.form.notifyLine1 = this._mblCargoDoc.notifyLine1
      this.form.notifyLine2 = this._mblCargoDoc.notifyLine2
      this.form.notifyLine3 = this._mblCargoDoc.notifyLine3
      this.form.notifyLine4 = this._mblCargoDoc.notifyLine4
      this.form.notifyLine5 = this._mblCargoDoc.notifyLine5
      this.form.notifyLine6 = this._mblCargoDoc.notifyLine6
      this.form.notifyLine7 = this._mblCargoDoc.notifyLine7
      this.form.notifyCode = this._mblCargoDoc.notifyCode
      this.form.notifyCountry = this._mblCargoDoc.notifyCountry
      this.form.notifyCity = this._mblCargoDoc.notifyCity
      this.form.notifyProvince = this._mblCargoDoc.notifyProvince
      this.form.notifyZipCode = this._mblCargoDoc.notifyZipCode
      this.form.notifyMobile = this._mblCargoDoc.notifyMobile
      this.form.notifyEmail = this._mblCargoDoc.notifyEmail
      this.form.notifyFax = this._mblCargoDoc.notifyFax
      this.form.notifyContact = this._mblCargoDoc.notifyContact

      this.form.BLNumber = this._mblCargoDoc.BLNumber
      this.form.paymentPlaceBL = this._mblCargoDoc.paymentPlaceBL
      this.form.quantity = this.job.quantityActual
      this.form.weight = this.job.weightActual
      this.form.cubage = this.job.cubageActual
      this.form.chargeWeight = this.job.chargeWeight
      this.form.signPlaceBL = this._mblCargoDoc.signPlaceBL
      this.form.signDateBL = this._mblCargoDoc.signDateBL

      // 包装
      this.form.packing = this.job.packing
      this.form.cargoEnglishName = this._mblCargoDoc.cargoEnglishName
      this.form.alsoNotify = this._mblCargoDoc.alsoNotify
      this.form.mark = this._mblCargoDoc.mark

      this.form.releaseType = this._mblCargoDoc.releaseType
      // 付款方式
      const paymentTerm = this.paymentTermList.find(p => p.code === this.job.paymentTermMBL)
      this.form.paymentTerm = paymentTerm ? paymentTerm.name : ''

      for (const item of this.view.splitOrderFinalRowData) {
        // 件数
        this.form.quantity = this.form.quantity - item.quantity
        // 重量
        this.form.weight = this.form.weight - item.weight
        // 体积
        this.form.cubage = this.form.cubage - item.cubage
      }
      if (isNaN(this.form.weight)) {
        this.form.weight = 0
      }
      if (isNaN(this.form.cubage)) {
        this.form.cubage = 0
      }
    }
    if (this.job.typeMBL === BillType.MERGE_BILL_TYPE.code) {
      this.form.hblNbr2 = this.job.jobNo
      this.form.mblNbr2 = this.job.mbl
    } else {
      const prefix = this.job.jobNo + '-'
      let curCode = 0
      for (const item of this.view.splitOrderFinalRowData) {
        const hblNbr2 = item.hblNbr2
        if (hblNbr2.startsWith(prefix)) {
          const code = Number(hblNbr2.substr(prefix.length))
          if (code && code > curCode) {
            curCode = code
          }
        }
      }
      this.form.hblNbr2 = this.job.jobNo + '-' + (curCode + 1)
    }
    this.form.state = 1
    this.form.jobUuid = this.job.uuid
    if (this.job.typeMBL === BillType.SPLIT_BILL_TYPE.code) {
      // 太平、巴士拆单默认生成一个mblNo
      if (this.view.editMblNoMode === 2 || this.view.editMblNoMode === 3) {
        // 根据单号规则 尾数+1
        this.form.mblNbr2 = await JobUtils.calculateMblNo(this.job)
      }
      this.view.splitOrder.rowData.push(this.form)
      this.view.curMbl = this.form
      await this.calculateChargeWeight()
      this.job.seaCargoDoc.push(this.form)
      setTimeout(() => {
        this.setSelectNode(this.view.splitOrderFinalRowData.length - 1)
      }, 0)
    }
    this.refreshSeaeqNumber()
    this.refreshQuantitySum()
    this.chargeEsaeq()
    this.changeContainer()
    this.ediGridChange()
  }
  /**
   * 移除拆单
   */
  onRemoveSliptDocEvent() {
    const selectedRows = this.view.splitOrder.gridApi.getSelectedRows()
    const row = selectedRows.length ? selectedRows[0] : null
    if (row) {
      this.$confirm(
        this.view.$t('Message.AreYouSureYouWantToDelete1') + row.hblNbr2 + this.view.$t('Message.AreYouSureYouWantToDelete2'),
        this.view.$t('Message.ConfirmDelete'), {
          confirmButtonText: this.view.$t('common.btn.ok'),
          cancelButtonText: this.view.$t('common.btn.cancel'),
          type: 'warning'
        }
      ).then(async() => {
        await this.onRemoveConfirmed(row)
        this.setSelectNode(0)
      }).catch(() => { })
    } else {
      this.$message.warning(this.view.$t('Message.PleaseSelectMBLNo'))
    }
  }
  async onRemoveConfirmed(row) {
    if (row.uuid) {
      row.deleted = true
      const tempRowData = this.view.splitOrder.rowData
      // this.view.splitOrder.rowData = []
      // this.view.$nextTick(() => {
      //   this.view.splitOrder.rowData = tempRowData
      // })
      const index = tempRowData.indexOf(row)
      if (index > -1) {
        // 找到原来的元素删除，并将row添加到删除元素的位置
        tempRowData.splice(index, 1, row)
      }
      const cargoDoc = this.job.seaCargoDoc.find(p => p.uuid === row.uuid)
      if (cargoDoc) cargoDoc.deleted = true
      // const cargoDocIndex = this.job.seaCargoDoc.findIndex(p => p.uuid === row.uuid)
      // if (cargoDocIndex >= 0) {
      //   this.job.seaCargoDoc.splice(cargoDocIndex, 1)
      // }
    } else {
      const index = this.view.splitOrder.rowData.findIndex(p => p === row)
      if (index >= 0) {
        this.view.splitOrder.rowData.splice(index, 1)
      }
      const cargoDocIndex = this.job.seaCargoDoc.findIndex(p => p === row)
      if (cargoDocIndex >= 0) {
        this.job.seaCargoDoc.splice(cargoDocIndex, 1)
      }
    }
    if (this.view.splitOrderFinalRowData.length > 0) {
      this.form = this.view.splitOrderFinalRowData[0]
    } else {
      // 不存到数据库
      this.form = new SeaCargoDoc().fillDefaultValue().getData()
      this.form.releaseType = 1
    }

    this.refreshSeaeqNumber()
    this.refreshQuantitySum()
    this.resetColor()
    if (this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code ||
        this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_SHIPPER_CONFIRMED.code) {
      await this.loadCheckDocs()
    }
  }
  /**
   * change Part of
   */
  chargeEsaeq() {
    this.form.seaeq = SeaExportUtils.getJoinSeaDocSeaEQDesc(this.form, this.job, this.form.printParam1, 'Part of')
  }
  /**
   * change printParam3
   */
  async changeContainer() {
    this.form.container = await SeaExportUtils.getContainerQWCDesc(this.form, this.form.printParam3)
  }
  /**
   * select job
   */
  onSelectionChange(data) {
    if (!data) {
      return
    }
    this.fillModel()
    this.form = data
    this.refreshQuantitySum()
    this.printStateChange()
    this.ediGridChange()
    this.showDocState()
    this.resetColor()
    if (this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code || this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_SHIPPER_CONFIRMED.code) {
      this.loadCheckDocs()
    }
  }
  /**
   * 添加并单
   */
  onJobsAdd() {
    const excludeUuids = Array.from(this.view.mergeOrderFinalRowData, p => p.uuid)
    Object.assign(this.view.searchBillNoDialog.params, {
      selectType: 'multiple',
      docType: CargoDocConsts.MBL2,
      job: this.job,
      useDefaultCondition: true,
      excludeUuids
    })
    this.view.searchBillNoDialog.selectHandler = p => { this.selectionItemsHandler(p) }
    this.view.searchBillNoDialog.visible = true
  }
  async selectionItemsHandler(data) {
    if (!this.view.mblMergeUpdateMainNumber) {
      this.view.isItCleared = await JobUtils.vesselOrVoyageChange2(data, this.job, this.view)
    }
    const rowData = this.view.mergeOrder.rowData
    const jobKeySet = {}
    for (const seaJob of rowData) {
      jobKeySet[seaJob.uuid] = true
    }
    const selectedJobs = []
    for (const sJob of data) {
      if (!jobKeySet[sJob.uuid]) {
        selectedJobs.push(sJob)
        rowData.push(sJob)
        this.view.addJoinMergeJobList.push({ masterJobUuid: this.job.uuid, key: sJob.uuid, version: sJob.version, type: 'MBL', vessel: this.job.vessel, voyageFlight: this.job.voyageFlight, atd: this.job.atd, mbl: this.job.mbl, containerLoadType: sJob.containerLoadType })
      }
    }
    SeaExportUtils.jointJobsMBL(this.job, this.form, selectedJobs)
    this.refreshQuantitySum()
    let tempCargoEnglishName = this.form.cargoEnglishName
    const obj = SeaExportUtils.jointSeqContainerInfo(this.form.seaeq, this.form.container, this.job, this.form, selectedJobs, Number(this.form.chargeWeight))
    if (tempCargoEnglishName) {
      tempCargoEnglishName += '\n'
    }
    if (this.mergerOfEnglishNames === 1) {
      tempCargoEnglishName += obj.cargoEnglishName2
    } else {
      tempCargoEnglishName += obj.cargoEnglishName
    }
    this.form.cargoEnglishName = tempCargoEnglishName
    this.form.chargeWeight = obj.chargeWeight
    // 唛头
    let mark = this.form.mark
    if (obj.mark) {
      if (mark) {
        mark = mark + '\n' + obj.mark
      } else {
        mark = obj.mark
      }
    }
    this.form.mark = mark
    for (const item of selectedJobs) {
      item.todo = 'new'
    }
  }
  /**
   * 移除并单
   */
  onJobsRemove() {
    const doc = this.view.mergeOrder.gridApi.getSelectedRows()[0]
    if (doc) {
      this.$confirm(
        this.view.$t('Message.AreYouSureYouWantToDelete1') + doc.jobNo + this.view.$t('Message.AreYouSureYouWantToDelete2'),
        this.view.$t('Message.ConfirmDelete'), {
          confirmButtonText: this.view.$t('common.btn.ok'),
          cancelButtonText: this.view.$t('common.btn.cancel'),
          type: 'warning'
        }
      ).then(() => {
        this.on_jobsRemoveConfirmed(doc)
      }).catch(() => { })
    } else {
      this.$message.warning(this.view.$t('SeaExport.SelectARecord'))
      return
    }
  }
  on_jobsRemoveConfirmed(job) {
    // 先保留原始的值，如果调用后端请求失败，则还原这几个字段
    const oldCargoDoc = {
      quantity: this.form.quantity,
      weight: this.form.weight,
      cubage: this.form.cubage,
      chargeWeight: this.form.chargeWeight
    }
    // 件数
    let quantity = this.form.quantity - job.quantityActual
    // 重量和体积 不加这个校验，是因为三者页面组件不同
    if (quantity < 0) {
      quantity = 0
    }
    // 重量
    const weight = this.form.weight - job.weightActual
    // 体积
    const cubage = this.form.cubage - job.cubageActual
    // 计费重量
    const chargeWeight = this.form.chargeWeight - job.chargeWeight
    // 如果提单是已经真是存在的,此时立即调用移除并单操作，并且已经真实并入的才能调用后台
    if (this.form.uuid && job && job.jointMasterMBLUuid) {
      const param = {}
      param.docType = 'MBL2'
      param.job = { key: this.job.uuid, version: this.job.version }
      param.unJob = { key: job.uuid, version: job.version }
      param.cargoDoc = {
        key: this.form.uuid,
        version: this.form.version,
        quantity: isNaN(quantity) ? 0 : Number(quantity),
        weight: isNaN(weight) ? 0 : Number(weight),
        cubage: isNaN(cubage) ? 0 : Number(cubage),
        chargeWeight: isNaN(chargeWeight) ? 0 : Number(chargeWeight)
      }
      unJointSlavesHblOrMbl(param).then(res => {
        if (res.data) { // 由于是编辑状态下,所以删除操作成功以后要更新对应的字段以及版本号
          const index = this.view.mergeOrder.rowData.findIndex(p => p.uuid === job.uuid)
          if (index >= 0) {
            this.view.mergeOrder.rowData.splice(index, 1)
          }
          if (res.data.job) {
            this.job.version = res.data.job.version
            this.job.joinFlagMBL = res.data.job.joinFlagMBL
            this.job.jointMasterMBLUuid = res.data.job.jointMasterMBLUuid
            this.view.$emit('syncData', {
              jointMasterMBLUuid: this.job.jointMasterMBLUuid,
              joinFlagMBL: this.job.joinFlagMBL,
              version: this.job.version
            })
          }
          if (res.data.cargoDoc) {
            this.form.version = res.data.cargoDoc.version
            this.form.quantity = res.data.cargoDoc.quantity
            this.form.weight = res.data.cargoDoc.weight
            this.form.cubage = res.data.cargoDoc.cubage
            this.form.chargeWeight = res.data.cargoDoc.chargeWeight
            this.view.$emit('syncData', { cargoDoc: '', seaCargoDoc: '', isCompleteRow: false })
          }
          this.view.$emit('syncData', { jointSlavesMBL: '', isCompleteRow: false })
          if (this.view.mergeOrder.rowData.length <= 0) {
            // CARGO-36378 HBL普票业务，存在并单数据
            if (this.job.seaCargoDoc && this.job.seaCargoDoc.length > 0) {
              for (const item of this.job.seaCargoDoc) {
                if (item.uuid === res.data.cargoDoc.uuid) {
                  item.deleted = true
                }
              }
            }
          }
        }
      }).catch(() => {
        this.form.quantity = oldCargoDoc.quantity
        this.form.weight = oldCargoDoc.weight
        this.form.cubage = oldCargoDoc.cubage
        this.form.chargeWeight = oldCargoDoc.chargeWeight
      })
    } else {
      // 移除addJoinMergeJobList中的数据
      const addJoinMergeJobList = this.view.addJoinMergeJobList
      if (addJoinMergeJobList && addJoinMergeJobList.length > 0) {
        for (let i = 0; i < addJoinMergeJobList.length; i++) {
          if (addJoinMergeJobList[i].key === job.uuid) {
            addJoinMergeJobList.splice(i, 1)
            break
          }
        }
      }

      const index = this.view.mergeOrder.rowData.findIndex(p => p.uuid === job.uuid)
      if (index >= 0) {
        this.view.mergeOrder.rowData.splice(index, 1)
      }
      this.form.quantity = quantity
      this.form.weight = weight
      this.form.cubage = cubage
      this.form.chargeWeight = chargeWeight
    }
    this.resetColor()
    if (this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code || this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_SHIPPER_CONFIRMED.code) {
      this.loadCheckDocs()
    }
  }
  packing_Change(data) {
    this.form.packing = data.value
    this.refreshQuantitySum()
  }
  quantity_Change(value) {
    this.form.quantity = value
    this.refreshQuantitySum()
  }
  onClear(type, detail) {
    CargoDocUtil.onClear(this.form, type, detail)
  }
  getPaymentTermNameByCode(code) {
    if (!code) {
      return ''
    }
    const paymentTerm = this.paymentTermList.find(p => p.code === code)
    if (paymentTerm) {
      return paymentTerm.name
    }
    return code
  }
  printStateChange() {
    // view.enablePrint = (view.job.typeMBL == BillType.MERGE_BILL_TYPE.code || view.gdMBL2.selectedItem != null)
  }
  ediGridChange() {
    new SeaCargoDoc(this.form).getEdiContainer().then(data => {
      this.view.rowData = data
    })
  }
  async paymentImportData(type) {
    CargoDocUtil.paymentImportData(this.form, type)
  }
  /**
   * select
   */
  async usageSelectCallBackFunc(usages) {
    this.view.rowData = await new SeaCargoDoc(this.form).getEdiContainer()
    if (usages && usages.length > 0) {
      const newRows = []
      // 是否并单，并单的情况下一个箱子只能加入一次，不能反复加入
      const isMerge = this.job.typeMBL === BillType.MERGE_BILL_TYPE.code
      for (const usage of usages) {
        let isExist = false
        if (isMerge) {
          for (const row of this.view.rowData) {
            if (row.containerUsageUuid === usage.uuid) {
              isExist = true
              break
            }
          }
          if (isExist) {
            continue
          }
        } else {
          for (const row of this.view.rowData) {
            if (row.containerUsageUuid === usage.uuid) {
              row.containerNo = usage.container.containerNo
              row.sealNo = usage.container.sealNo
              row.eqType = usage.container.eqType
              row.eqSize = usage.container.eqSize
              if (row.deleted) {
                row.quantity = usage.quantity
                row.weight = usage.weight
                row.cubage = usage.cubage
                row.deleted = false
                row.used = true // 记录已经被使用了
              } else {
                row.quantity = (Number(row.quantity) || 0) + usage.quantity
                row.weight = (Number(row.weight) || 0) + usage.weight
                row.cubage = (Number(row.cubage) || 0) + usage.cubage
                row.deleted = false
                row.used = true // 记录已经被使用了
              }
              isExist = true
              break
            }
          }
        }
        if (!isExist) {
          const ec = new EDIContainer().fillDefaultValue().getData()
          ec.deleted = false
          ec.used = true // 记录已经被使用了
          ec.containerNo = usage.container.containerNo
          ec.sealNo = usage.container.sealNo
          ec.eqType = usage.container.eqType
          ec.eqSize = usage.container.eqSize
          ec.quantity = usage.quantity
          ec.weight = usage.weight
          ec.cubage = usage.cubage
          ec.cargoDocUuid = this.form.uuid
          ec.containerUsageUuid = usage.uuid
          newRows.push(ec)
        }
      }
      this.view.rowData.push(...newRows)
    }
    await this.refreshSeqContainer()
    // 拆单专用
    if (this.job.typeMBL === BillType.SPLIT_BILL_TYPE.code && !this.view.isXy) {
      this.refreshEdiGrid()
    }
  }
  existContainerUsage(u) {
    const finalRowData = this.view.rowData.filter(p => !p.deleted && !p.used)
    for (const item of finalRowData) {
      if (u.container.eqSize === item.eqSize && u.container.eqType === item.eqType &&
        u.container.containerNo === item.containerNo && u.container.sealNo === item.sealNo) {
        return true
      }
    }
    return false
  }
  /**
   * refresh  刷新计件重体
   */
  refreshEdiGrid() {
    if (this.view.rowData && this.view.rowData.length > 0) {
      let quantity = 0
      let weight = 0
      let cubage = 0
      const rowData = this.view.rowData.filter(p => !p.deleted)
      if (rowData && rowData.length > 0) {
        for (const item of rowData) {
          quantity += Number(item.quantity)
          weight += Number(item.weight)
          cubage += Number(item.cubage)
        }
      }
      this.form.quantity = quantity
      this.form.weight = weight
      this.form.cubage = cubage

      CargoDocUtil.calculateSEChargeWeight(this.form)
    } else {
      // 移除完箱子后清空件毛体
      this.form.quantity = 0
      this.form.weight = 0
      this.form.cubage = 0
      this.form.chargeWeight = 0
    }
  }
  /**
   * 拆单计费重量修改计算
   */
  async calculateChargeWeight() {
    CargoDocUtil.calculateSEChargeWeight(this.form)
  }
  /**
   * refresh
   */
  async refreshSeqContainer() {
    this.form.seaeq = SeaExportUtils.getJoinSeaDocSeaEQDesc(this.form, this.job, this.form.printParam1, 'Part of')
    this.form.container = await SeaExportUtils.getContainerQWCDesc(this.form, this.form.printParam3)
  }
  /**
   * 取回(撤销取回)和放单(撤销放单)
   */
  async btnGetBackClickHandler() {
    this.loading = getLoading()
    try {
      if (this.form.uuid) {
        let params = null
        if (Number(this.form.bliStatus) === CargoDocCfmState.CARGODOC_CFM_STATE_GET_BACKED.code) {
          // 撤销取回
          params = {
            bliStatus: CargoDocCfmState.CARGODOC_CFM_STATE_WKS.code,
            getBackDate: '',
            operation: CargoDocCfmState.CARGODOC_CANCEL_GET_BACK
          }
        } else {
          // 取回
          params = {
            bliStatus: CargoDocCfmState.CARGODOC_CFM_STATE_GET_BACKED.code,
            getBackDate: new Date(),
            operation: CargoDocCfmState.CARGODOC_GET_BACK
          }
          this.manualTriggerAndUpateFunc(null, AutomaticReleaseConstants.MBL_RETRIEVE.code)
        }
        const result = await SeaCargoDoc.updateProperties([this.form.uuid], params)
        CargoDocUtil.syncData(result['seaCargoDocs'], this.form)
        this.job.seaCargoDoc = result['seaCargoDocs']
        this.saveReleaseStateStateHandler()
      }
    } finally {
      this.loading.close()
    }
  }
  async btnReleasingClickHandler() {
    if (this.form.uuid && this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_RELEASED.code) {
      // 撤销放单
      const obj = {}
      obj.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_WKS.code
      obj.releaseDate = ''
      obj.operation = CargoDocCfmState.CARGODOC_CANCEL_RETURN
      obj.surrenderedNo = ''
      obj.releaseState = CargoDocCfmState.CARGODOC_CAN_SINGLE_RELEASE
      obj.releaseBy = 0

      const result = await SeaCargoDoc.updateProperties([this.form.uuid], obj)
      this.job.seaCargoDoc = result['seaCargoDocs']
      this.saveReleaseStateStateHandler()
    } else if (this.form.uuid) {
      // 放单
      const releaseState = await this.checkReleaseRuleEngineState()
      if (releaseState !== ReleaseState.SINGLERELEASE.code) {
        return
      }
      this.manualTriggerAndUpateFunc('release', AutomaticReleaseConstants.MBL_RELEASE.code)
    }
  }
  async checkReleaseRuleEngineState() {
    if (!this.job.uuid) {
      return Number(this.form.releaseState)
    }

    const res = await executeRuleEngine({ jobUuid: this.job.uuid, model: 1 })
    if (res.data && Array.isArray(res.data.seaCargoDocs)) {
      this.job.seaCargoDoc = res.data.seaCargoDocs
      const currentDoc = res.data.seaCargoDocs.find(item => item.uuid === this.form.uuid)
      if (currentDoc) {
        Object.assign(this.form, currentDoc)
        this.showDocState()
      }
    }
    return Number(res.data.releaseState)
  }
  async commitSurrenderedNoHandler(value) {
    const obj = {}
    obj.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_RELEASED.code
    obj.releaseDate = new Date()
    obj.operation = CargoDocCfmState.CARGODOC_RETURN
    obj.surrenderedNo = value.value
    obj.releaseState = ReleaseState.ONSINGLERELEASE.code
    const result = await SeaCargoDoc.updateProperties([this.form.uuid], obj)
    this.job.seaCargoDoc = result['seaCargoDocs']
    this.saveReleaseStateStateHandler()
  }
  // 修改放单状态
  async updateReleasestateFunc(uuid, releaseState) {
    const data = {
      uuid,
      releaseState
    }
    const res = await updateReleasestate(data)
    if (res.ok) {
      this.view.lblReleaseState = ColumnUtils.releaseStateLabelFunc(releaseState)
    }
  }
  // 手动触发放单规则
  async manualTriggerAndUpateFunc(type, btnType) {
    const params = {
      uuid: this.form.uuid,
      state: 0,
      setting: type === 'release' ? 1 : 0,
      btnType: btnType
    }
    const res = await manualTriggerAndUpate(params)
    if (res.ok) {
      if (res.data.result === 2) {
        const messages = []
        const createElement = this.view.$createElement
        messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.businessNumber') + res.data.jobNo))
        if (res.data.mbl) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.mblNo') + res.data.mbl))
        }
        if (res.data.hbl) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.hblNo') + res.data.hbl))
        }
        if (res.data.tip.accountCompanyName) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.partners') + res.data.tip.accountCompanyName))
        }
        if (res.data.tip.accountOverCreditLimitDate) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.paymentDays').replace('{0}', this.view.$t('SeaExport.Exceeded'))))
        }
        if (res.data.tip.accountOverCreditLimitAmount) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.lines').replace('{0}', res.data.tip.accountOverCreditLimitAmount)))
        }
        if (res.data.tip.agentCompanyName) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.partners') + res.data.tip.agentCompanyName))
        }
        if (res.data.tip.agentOverCreditLimitDate) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.paymentDays').replace('{0}', this.view.$t('SeaExport.Exceeded'))))
        }
        if (res.data.tip.agentOverCreditLimitAmount) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.lines').replace('{0}', res.data.tip.agentOverCreditLimitAmount)))
        }
        if (res.data.tip.customerCompanyName) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.partners') + res.data.tip.customerCompanyName))
        }
        if (res.data.tip.customerOverCreditLimitDate) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.paymentDays').replace('{0}', this.view.$t('SeaExport.Exceeded'))))
        }
        if (res.data.tip.customerOverCreditLimitAmount) {
          messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.lines').replace('{0}', res.data.tip.customerOverCreditLimitAmount)))
        }
        messages.push(createElement('p', null, this.view.$t('ReleaseNotes.lineCreditDialog.continueOrders')))
        if (type === 'release') {
          await this.view.$confirm('', {
            title: this.view.$t('ReleaseNotes.lineCreditDialog.title'),
            message: createElement('div', null, messages),
            confirmButtonText: this.view.$t('ReleaseNotes.lineCreditDialog.confirm'),
            cancelButtonText: this.view.$t('ReleaseNotes.lineCreditDialog.cancel'),
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: 'warning'
          }).then(() => {
            this.view.$prompt(this.view.$t('SeaExport.ReleaseOrderNumber'), this.view.$t('SeaExport.EnterReleaseNumber'), {
              confirmButtonText: this.view.$t('CargoMsg.Cargo_Confirm'),
              cancelButtonText: this.view.$t('SeaExport.Cancel')
            }).then(value => {
              this.commitSurrenderedNoHandler(value)
              this.updateReleasestateFunc(this.form.uuid, ReleaseState.ONSINGLERELEASE.code)
            })
          }).catch(() => {
            this.updateReleasestateFunc(this.form.uuid, ReleaseState.TO_BE_COLLECTED.code)
          })
        }
      }
      if (res.data.result === 1) {
        // 满足改为可放单
        if (type === 'release') {
          this.form.releaseState = 2
        } else {
          if (this.form.releaseState !== 2) {
            this.form.releaseState = 1
          }
        }
        this.view.lblReleaseState = ColumnUtils.releaseStateLabelFunc(this.form.releaseState)
        this.view.$message.success(this.view.$t('ReleaseNotes.lineCreditDialog.through'))
      }
      if (res.data.result === 0 && type === 'release') {
        this.view.$prompt(this.view.$t('SeaExport.ReleaseOrderNumber'), this.view.$t('SeaExport.EnterReleaseNumber'), {
          confirmButtonText: this.view.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.view.$t('SeaExport.Cancel')
        }).then(value => {
          this.commitSurrenderedNoHandler(value)
        })
      }
    }
  }
  saveReleaseStateStateHandler(e) {
    this.view.$message.success(this.view.$t('SeaExport.StatusModefySuccessfully'))
    this.loadCargoDoc2Handler(this.job.seaCargoDoc)
  }
  showScac() {
    const company = this.context.companyList.find(p => p.cmpIdx === this.job.carrierId)
    this.view.txtCarrierScAc = company ? company.scac : ''
    const company1 = this.context.companyList.find(p => p.cmpIdx === this.job.destinationAgent)
    this.view.txtBookingAgentScAc = company1 ? company1.scac : ''
  }
  showDocState() {
    const isZh = this.$i18n.locale === 'zh'
    const releaseState = ReleaseState.getReleaseStateByCode(this.form.releaseState)
    if (releaseState) {
      this.view.lblReleaseState = isZh ? releaseState.chineseName : releaseState.englishName
    }
    const cfmState = CargoDocCfmState.getCargoDocCfmStateByCode(this.form.cfmState)
    if (cfmState) {
      this.view.lblCfrState = isZh ? cfmState.chineseName : cfmState.englishName
    }
    const bliStatus = CargoDocCfmState.getCargoDocBliStateByCode(this.form.bliStatus)
    if (bliStatus) {
      this.view.billLadingIssued = isZh ? bliStatus.chineseName : bliStatus.englishName
    }
  }
  refreshQuantitySum() {
    const packing = this.packingList.find(p => p.code === this.form.packing)
    this.form.quantitySum = StrUtils.jsdx(this.form.quantity, packing ? packing.name : '')
  }
  refreshSeaeqNumber() {
    this.form.containerSum = ContainerUtil.getSeaeqNumberStr(this.job)
  }
  /**
   * 发货人选择
   */
  async shipperAutoCompleteChange(data, detail) {
    this.form.shipperId = data.value || 0
    if (data.value) {
      const company = new Company(data)
      await company.getMainfestAddress()
      CargoDocUtil.applyShipperManifestAddress(this.form, data, detail)
    } else {
      CargoDocUtil.onClear(this.form, 1, detail)
    }
    await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.view.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, 'shipper', 1)
  }
  /**
   * 收货人选择
   */
  async consigneeAutoCompleteChange(data, detail) {
    this.form.consigneeId = data.value || 0
    if (data.value) {
      const company = new Company(data)
      await company.getMainfestAddress()
      CargoDocUtil.applyConsigneeManifestAddress(this.form, data, detail)
    } else {
      CargoDocUtil.onClear(this.form, 2, detail)
    }
    await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.view.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, 'consignee', 1)
  }
  /**
   * 通知人选择
   */
  async notifyAutoCompleteChange(data, detail) {
    this.form.notifyId = data.value || 0
    if (data.value) {
      const company = new Company(data)
      await company.getMainfestAddress()
      CargoDocUtil.applyNotifyManifestAddress(this.form, data, detail)
    } else {
      CargoDocUtil.onClear(this.form, 3, detail)
    }
    await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.view.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, 'notify', 1)
  }

  setSelectNode(index) {
    const selectedNode = this.view.splitOrder.gridApi.getModel().rowsToDisplay[index]
    selectedNode.setSelected(true)
  }
  // 获取当前Job的并单数据的英文名品
  async getCargoEnglishNameFromMergeJob() {
    const job = new SeaExportJob(this.job)
    const jointSlavesMBL = await job.getJointSlavesMBL()
    if (jointSlavesMBL) {
      let text = this.form.cargoEnglishName
      for (const mergeJob of jointSlavesMBL) {
        const cargoDoc = await new SeaExportJob(mergeJob).getMainMbl()
        if (cargoDoc) {
          if (cargoDoc.cargoEnglishName) {
            if (text) {
              text = text + '\n' + cargoDoc.cargoEnglishName
            } else {
              text = cargoDoc.cargoEnglishName
            }
          }
        }
      }
      this.form.cargoEnglishName = text
    }
  }
  // 获取当前Job的并单数据的唛头
  async getMarkFromMergeJob() {
    const job = new SeaExportJob(this.job)
    const jointSlavesMBL = await job.getJointSlavesMBL()
    if (jointSlavesMBL) {
      let text = this.form.mark
      for (const mergeJob of jointSlavesMBL) {
        const cargoDoc = await new SeaExportJob(mergeJob).getMainMbl()
        if (cargoDoc) {
          if (cargoDoc.mark) {
            if (text) {
              text = text + '\n' + cargoDoc.mark
            } else {
              text = cargoDoc.mark
            }
          }
        }
      }
      this.form.mark = text
    }
  }
  resetColor() {
    for (const key in this.view.variableCss) {
      if (key === 'cargoEnglishName' && this.form.cargoEnglishName.length >= 45) {
        continue
      } else if (key === 'mark' && this.form.mark.length >= 22) {
        continue
      }
      this.view.variableCss[key] = ''
    }
  }
  /**
   * 获取最近修改的对单记录
   */
  async loadCheckDocs() {
    const checkDocHistories = await CheckCargoDocHistory.queryDocHistoryByTime(this.form.uuid)
    this.queryTopCheckDocHistoriesHandler(checkDocHistories)
  }
  queryTopCheckDocHistoriesHandler(checkDocHistories) {
    this.comparedCargoDocIsModified(checkDocHistories)
  }
  /**
   * 对单后把有修改的内容显示红色
   */
  comparedCargoDocIsModified(checkDocHistories) {
    if (checkDocHistories && checkDocHistories.length > 0) {
      const variableCss = this.view.variableCss
      // 获取对单记录的第一条记录，根据是否有标识字段判断是否对单时修改了字段,有字段修改的情况去改变字段颜色
      const firstCheckDaoHistory = checkDocHistories[0]
      if (firstCheckDaoHistory.fieldName !== 'noChange') {
        for (const checkDocHistory of checkDocHistories) {
          const fieldName = checkDocHistory.fieldName
          if (variableCss.hasOwnProperty(fieldName)) {
            if (fieldName === 'cargoEnglishName' && this.form.cargoEnglishName.length >= 45) {
              continue
            } else if (fieldName === 'mark' && this.form.mark.length >= 22) {
              continue
            }
            this.checkHistoryTextMapChanged(checkDocHistory, checkDocHistories)
          }
        }
      }
    }
  }
  /**
   * 对单内容
   */
  checkHistoryTextMapChanged(checkDocHistory, checkDocHistories) {
    switch (checkDocHistory.fieldName) {
      case 'shipperLine':
        this.checkHistoryByShipperConsigneeNotifyLine('shipperLineOld', 'shipperLine', checkDocHistory, checkDocHistories)
        break
      case 'consigneeLine':
        this.checkHistoryByShipperConsigneeNotifyLine('consigneeLineOld', 'consigneeLine', checkDocHistory, checkDocHistories)
        break
      case 'notifyLine':
        this.checkHistoryByShipperConsigneeNotifyLine('notifyLineOld', 'notifyLine', checkDocHistory, checkDocHistories)
        break
      default:
        this.view.variableCss[checkDocHistory.fieldName] = 'red'
        break
    }
  }
  /**
   * 检查收发通知人是否发生变化
   */
  checkHistoryByShipperConsigneeNotifyLine(oldField, textField, checkDocHistory, checkDocHistories) {
    const line = checkDocHistory.fieldValue
    const oldLine = this.getDocHistoryShipperConsigneeNotify(oldField, checkDocHistories)
    const lines = line.split('|')
    const oldLines = oldLine.split('|')
    for (let i = 0; i < lines.length; ++i) {
      const index = i + 1
      const line2 = lines[i].replace('\r\n', '')
      const lineOld2 = oldLines[i].replace('\r\n', '')
      if (line2 !== lineOld2) {
        this.view.variableCss[textField] = 'red'
        this.view.variableCss[textField + index] = 'red'
      }
    }
  }
  portChange(p, field) {
    const form = this.form
    form[field + 'Code'] = p.value
    form[field] = p.englishName
  }
  /**
   * 获取上一个版本收发通历史的数据
   */
  getDocHistoryShipperConsigneeNotify(fieldName, checkDocHistories) {
    for (let i = 0; i < checkDocHistories.length; i++) {
      if (checkDocHistories[i].fieldName === fieldName) {
        return checkDocHistories[i].fieldValue
      }
    }
    return ''
  }
  async statusHistoryWaitConfirmSuccessHandler() {
    await new StatusChangeHistory({
      statusType: 1, // 表示放单管理
      businessDataId: this.form.uuid,
      statusValue: CargoDocCfmState.CARGODOC_WAIT_FOR_CONFIRM
    }).save()
    await this.getCfmBillAddressHandler()
  }
  async getCfmBillAddressHandler(event = null) {
    await new SeaExportJob(this.job).getSeaCargoDoc()
    await this.changeJob()
    await this.fillView()
  }

  btnRequestReleasingClickHandler() {
    const { requestReleaseState, uuid } = this.view.form
    const uuids = [uuid]
    if (requestReleaseState === 0) {
      this.loading = getLoading()
      requestRelease(uuids).then(async res => {
        this.loading.close()
        this.view.form.requestReleaseState = 1
        await SeaCargoDoc.handlerCargoDocForRequestRelease(this.view.form)
        this.view.lblReleaseState = ColumnUtils.releaseStateLabelFunc(Number(res.data[uuid].releaseState))
        this.view.$message.success(this.view.$t('SeaExport.StatusModefySuccessfully'))
      }).catch(() => {
        this.loading.close()
      })
      return
    }
    this.loading = getLoading()
    cancelRequestRelease(uuids).then(async res => {
      this.loading.close()
      this.view.form.requestReleaseState = 0
      await SeaCargoDoc.handlerCargoDocForRequestRelease(this.view.form)
      this.view.$message.success(this.view.$t('SeaExport.StatusModefySuccessfully'))
    }).catch(() => {
      this.loading.close()
    })
  }
}
